import { Component, OnInit } from '@angular/core';
import { FormGroup, Validators, FormBuilder, FormControl } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';
import { RestService } from 'src/app/services/rest/rest.service';
import { UtilsService } from 'src/app/services/utils/utils.service';
import { Client, EmailStructure, ContactStructure, AddressStructure } from 'src/app/interfaces/client';
import { Zona } from 'src/app/interfaces/zona';
import { Promotion } from 'src/app/interfaces/promocion';
import { Tarifa } from 'src/app/interfaces/tarifa';

// import { Chart } from 'chart.js';
import { registerLocaleData } from '@angular/common';
import es from '@angular/common/locales/es';
@Component({
  selector: 'app-cliente-detail',
  templateUrl: './cliente-detail.page.html',
  styleUrls: ['./cliente-detail.page.scss'],
})
export class ClienteDetailPage implements OnInit {
  selectedView = 'main';
  client: Client;
  zonas: Zona[];
  promos: Promotion[];
  tarifas: Tarifa[];

  selectedTarifas = 0;
  selectedPromos = 0;

  emailList: EmailStructure[] = [];
  contactList: ContactStructure[] = [];
  addressList: AddressStructure[] = [];

  form: FormGroup;

  selectedTab = 'info';
  clientId: any;

  clientStatistics: any = {};
  statisticsValues: any = [];
  start = '';
  end = '';

  constructor(private fb: FormBuilder,
    private route: ActivatedRoute,
    private location: Location,
    private rest: RestService,
    private utils: UtilsService,
    private router: Router
  ) {
    this.form = this.fb.group({
      _id: [null, null],
      zona: [null, null],
      nombre: new FormControl(null, [Validators.required]),
      dfiscal: [null, null],
      team: [null, null],
      t_documento: [null, null],
      documento: [null, null],
      correo: [null, null],
      ccc: [null, null],
      camaras: [null, null],
      denominacion: [null, null],
      seriefacturaId: [null, null],
      showCuentaBank: [false, null],
      cuentaBank: [null, null],
      paga: [false, null],
      chino: [false, null],
      commentRequired: [null, null],
      priceAlbaran: [false, null],
      facturaMensual: [false, null],
      nImpres: [null, null],
      email: [null, null],
      contact: [null, null],
      address: [null, null],
      tarifa: [null, null],
      promocion: [null, null],
      role: [null, null],
      groupedDocumentNumber: [null, null]
    });
  }

  async ngOnInit() {
    registerLocaleData( es );
    this.clientId = this.route.snapshot.paramMap.get('id');
    await this.getZonas();
    await this.getPromo();
    await this.getTarifa();
    if (this.clientId !== 'new') {
      this.getClient(this.clientId);
    }
    this.getClientStats(this.clientId);
    // this.clientBuyStats();
    // this.productsStats();
  }

  async getClient(clientId: string) {
    await this.utils.showLoading();
    const result: any = await this.rest.getClient(clientId);
    this.client = result.body;

    if (this.client.email && this.client.email.length !== 0) {
      this.emailList = this.client.email;
    } else {
      this.emailList.push({
        value: '',
        name: ''
      }
      );
    }

    if (this.client.contact && this.client.contact.length !== 0) {
      this.contactList = this.client.contact;
    } else {
      this.contactList.push({
        value: '',
        name: ''
      });
    }

    if (this.client.address && this.client.address.length !== 0) {
      this.addressList = this.client.address;
    } else {
      this.addressList.push({
        value: '',
        name: ''
      });
    }

    const tarifaCliente = [];
    this.client.tarifa.forEach((elem: any) => {
      tarifaCliente.push(elem._id);
    });

    this.tarifas.forEach(tarifa => {
      if (tarifaCliente.includes(tarifa._id)) {
        tarifa.selected = true;
        this.selectedTarifas += 1;
      }
    });

    this.tarifas = this.tarifas.sort((a, b) => {
      if (a.product < b.product) { return -1; }
      if (a.product > b.product) { return 1; }
      return 0;
    });

    const promoCliente = [];
    this.client.promocion.forEach((elem: any) => {
      promoCliente.push(elem._id);
    });

    this.promos.forEach(promo => {
      if (promoCliente.includes(promo._id)) {
        promo.selected = true;
        this.selectedPromos += 1;
      }
    });

    this.promos = this.promos.sort((a, b) => {
      if (a.product < b.product) { return -1; }
      if (a.product > b.product) { return 1; }
      return 0;
    });

    console.log(this.client);
    this.form.patchValue(this.client);
    await this.utils.hideLoading();
  }

  async getZonas() {
    const result: any = await this.rest.getZonas();
    this.zonas = result.body.records;
    console.log(this.zonas);
  }

  async getPromo() {
    const result: any = await this.rest.getPromotiones();
    this.promos = result.body.records;
    console.log(this.promos);
  }

  async getTarifa() {
    const result: any = await this.rest.getTarifas();
    this.tarifas = result.body.records;
    console.log(this.tarifas);
    this.tarifas.sort((a, b) => {
      return (a.product as any) - (b.product as any) || a.price - b.price;
    });
  }

  changeView(view: string) {
    console.log('email modal');
    this.selectedView = view;
    // console.log(this.emailList);
  }

  addToList(list) {
    console.log(list);
    console.log(list);
    list.push({
      value: '',
      name: ''
    });
  }

  deleteFromList(list, index: number) {
    list.splice(index, 1);
  }

  saveEmails() {
    this.changeView('main');
    this.form.get('email').setValue(this.emailList);
  }

  saveContacts() {
    this.changeView('main');
    this.form.get('contact').setValue(this.contactList);
  }

  saveAdress() {
    this.changeView('main');
    this.form.get('address').setValue(this.addressList);
  }

  saveTarifas() {
    this.changeView('main');
    const saveTarifas: string[] = this.tarifas.filter(tarifa => tarifa.selected).map(tarifa => tarifa._id);
    this.selectedTarifas = saveTarifas.length;
    this.form.get('tarifa').setValue(saveTarifas);
  }

  savePromos() {
    this.changeView('main');
    const savePromos: string[] = this.promos.filter(promo => promo.selected).map(promo => promo._id);
    this.selectedPromos = savePromos.length;
    this.form.get('promocion').setValue(savePromos);
  }

  setBankAccount() {
    if(this.form.value.showCuentaBank) {
      if(this.form.value.seriefacturaId === "1" || this.form.value.seriefacturaId === "2") {
        this.form.value.cuentaBank = "bankAccount"
      }
      else if(this.form.value.seriefacturaId === "3" || this.form.value.seriefacturaId == "4") {
        this.form.value.cuentaBank = "iceventure"
      }
      else if(this.form.value.seriefacturaId === "5" || this.form.value.seriefacturaId == "6") {
        this.form.value.cuentaBank = "ahe"
      }
      else {
        this.form.value.cuentaBank = null;
      }
    }
    else {
      this.form.value.cuentaBank = null;
    }
  }

  goBack() {
    this.location.back();
  }

  async saveClient() {
    try {
      await this.utils.showLoading();
      if (this.form.valid) {
        this.setBankAccount();
        const client: Client = this.form.value;
        if (!client.contact) {
          client.contact = [];
        }
        if (!client.email) {
          client.email = [];
        }
        if (!client.address) {
          client.address = [];
        }
        if (!client.promocion) {
          client.promocion = [];
        }
        if (!client.tarifa) {
          client.tarifa = [];
        }
        if (!client.groupedDocumentNumber) {
          client.groupedDocumentNumber = null;
        }
        console.log(this.form.value);
        if (this.form.value._id) {
          const result = await this.rest.editClient(this.form.value);
          if (result) {
            this.utils.showToast('Guardado con exito');
            location.reload();
          }
        } else {
          const result = await this.rest.createClient(this.form.value);
          if (result) {
            this.utils.showToast('Guardado con exito');
            location.reload();
          }
        }
      }
      await this.utils.hideLoading();
      this.form.reset({});
    } catch (error) {
      await this.utils.hideLoading();
      console.log(error);
    }

  }

  selectTarifa(index) {
    console.log(index);
    const selectedProduct = this.tarifas[index].product;
    this.tarifas.forEach(tarifa => {
      if (selectedProduct === tarifa.product) {
        tarifa.selected = false;
      }
    });
    this.tarifas[index].selected = true;
    console.log(this.tarifas);
  }

  selectPromo(index) {
    console.log(index);
    const selectedProduct = this.promos[index]._id;
    console.log(selectedProduct);
    console.log(this.promos[index]);
    console.log(this.promos);
    this.promos.forEach(promo => {
      if (selectedProduct === promo._id) {
        promo.selected = promo.selected ? !promo.selected : true;
      }
      // console.log(promo.selected);
    });
    this.promos[index].selected = this.promos[index].selected ? !this.promos[index].selected : true;
  }

  checkValidFields() {
    console.log(this.form.value);
    if (this.form.value.nombre === null) {
      return true;
    }
  }

  async getClientStats(clientId: string, startDate = '', endDate = '') {
    try {
      if (startDate && endDate) {
        startDate = startDate.split('T')[0];
        endDate = endDate.split('T')[0];
      }
      const resp: any = await this.rest.getClientStatistics(clientId, startDate, endDate);
      if (resp && resp.body) {
        console.log(resp.body);
        this.clientStatistics = resp.body.result;
        if (this.clientStatistics) {
          this.statisticsValues = Object.values(this.clientStatistics);
        }
      }
    } catch (error) {
      console.log(error);
      await this.utils.showToast('Hubo un error extrayendo las estadísticas del cliente', 'danger');
    }
  }
}
